import React, { Component } from 'react'
import { connect } from 'react-redux'

import Divider from 'material-ui/Divider'
import TextField from 'material-ui/TextField'
import VendorFormStatusIcon from './StatusIcon'

import dataActions from 'actions/dataActions'
import { doc, dirtyRead } from 'selectors/common'
import Phones from './Phones'
import CategorySelect from './CategorySelect'
import VendorCombobox from './VendorCombobox'

let select = dirtyRead(
	(state, props) => ({
		vendor: doc(state, props.objectID)
	})
)

export class LeftSide extends Component{
	render(){
		let { props } = this
		let vendor = props.vendor
		let isMob=false
		return(
			<div
				className="wrapper"
				style={{
					 width: (props.colspan>1)?"50%":"100%"
   				   , overflowY: (props.colspan>1)?"scroll":"hidden"
				   , overflowX: "hidden"
				}}
			>
				<div style={{width: "100%", padding:"10px 30px 10px 20px", boxShadow:props.expanded?"0px 2px 1px rgba(0,0,0,0.3)":"0px 1px 1px rgba(0,0,0,0.3)", backgroundColor: "white"}}>
					<div style={{width:"100%"}}>
						<VendorCombobox objectID={vendor._id} />
					</div>
					<div style={{width:"100%"}}>
						<div style={{display:"inline-block", width: "32px", paddingLeft: "10px", position:"relative", left:"-15px", top:"10px"}}>
							<img
								src={"/manager/static/img/acct-green.png"}
								style={{
								  width: "20px"
								  , position: "relative"
								  , top: "-2px"
								}}
							/>
						</div>
						<TextField style={{position: "relative", width: "calc(100% - 30px)"}}
							hintText = "Account #"
							hintStyle={{fontStyle: "italic", fontSize: "14px"}}
							multiLine = {true}
							fullWidth={false}
							style={{
								width: "calc(100% - 50px)"
							  , position: "relative"
							  , marginTop: "-10px"
							  , marginLeft: "6px"
							  , display:"inline-block"
							}}
							inputStyle={{
								fontSize: "16px"
							}}
							underlineStyle={{
								left: "1px"
							  , borderBottom: "0px solid #b0bec4"
							}}
							floatingLabelStyle={{
								fontWeight: "100",
								fontSize: "14px"
							}}
							defaultValue={vendor.accountNumber}
							key={vendor.accountNumber}
							onBlur={(evt)=>{
								this.props.STAGE({_id: vendor._id, accountNumber: evt.target.value})
							}}
						/>
					</div><div style={{width:"100%"}}>
						<CategorySelect objectID={props.objectID} />
					</div><div style={{width:"100%"}}>
						<div style={{display:"inline-block", width: "32px", paddingLeft: "10px", position:"relative", left:"-15px", top:"10px"}}>
							<i className="material-icons" style={{color: "#5ae4c3"}}>location_on</i>
						</div>
						<TextField style={{position: "relative", width: "calc(100% - 30px)"}}
							hintText = "Address"
							hintStyle={{fontStyle: "italic", fontSize: "14px"}}
							multiLine = {true}
							fullWidth={false}
							style={{
								width: "calc(100% - 50px)"
							  , position: "relative"
							  , marginTop: "-10px"
							  , marginLeft: "6px"
							  , display:"inline-block"
							}}
							inputStyle={{
								fontSize: "16px"
							}}
							underlineStyle={{
								left: "1px"
							  , borderBottom: "0px solid #b0bec4"
							}}
							floatingLabelStyle={{
								fontWeight: "100",
								fontSize: "14px"
							}}
							defaultValue={vendor.address}
							key={vendor.address}
							onBlur={(evt)=>{
								this.props.STAGE({_id: vendor._id, address: evt.target.value})
							}}
						/>
					</div><div style={{width:"100%"}}>
						<div style={{display:"inline-block", width: "32px", paddingLeft: "10px", position:"relative", left:"-15px", top:"10px"}}>
							<i className="material-icons" style={{color: "#5ae4c3"}}>account_circle</i>
						</div>
						<TextField style={{position: "relative", width: "calc(100% - 30px)"}}
							hintText = "Contact name"
							hintStyle={{fontStyle: "italic", fontSize: "14px"}}
							multiLine = {true}
							fullWidth={false}
							style={{
								width: "calc(100% - 50px)"
							  , position: "relative"
							  , marginTop: "-10px"
							  , marginLeft: "6px"
							  , display:"inline-block"
							}}
							inputStyle={{
								fontSize: "16px"
							}}
							underlineStyle={{
								left: "1px"
							  , borderBottom: "0px solid #b0bec4"
							}}
							floatingLabelStyle={{
								fontWeight: "100",
								fontSize: "14px"
							}}
							defaultValue={vendor.contactName}
							key={vendor.contactName}
							onBlur={(evt)=>{
								this.props.STAGE({_id: vendor._id, contactName: evt.target.value})
							}}
						/>
					</div><div style={{width:"100%"}}>
						<div style={{display:"inline-block", width: "32px", paddingLeft: "10px", position:"relative", left:"-15px", top:"10px"}}>
							<i className="material-icons" style={{color: "#5ae4c3"}}>call</i>
						</div>
						<TextField style={{position: "relative", width: "calc(100% - 30px)"}}
							hintText = "Phone number"
							hintStyle={{fontStyle: "italic", fontSize: "14px"}}
							multiLine = {true}
							fullWidth={false}
							style={{
								width: "calc(100% - 50px)"
							  , position: "relative"
							  , marginTop: "-10px"
							  , marginLeft: "6px"
							  , display:"inline-block"
							}}
							inputStyle={{
								fontSize: "16px"
							}}
							underlineStyle={{
								left: "1px"
							  , borderBottom: "0px solid #b0bec4"
							}}
							floatingLabelStyle={{
								fontWeight: "100",
								fontSize: "14px"
							}}
							defaultValue={vendor.phoneNumber}
							key={vendor.phoneNumber}
							onBlur={(evt)=>{
								this.props.STAGE({_id: vendor._id, phoneNumber: evt.target.value})
							}}
						/>
					</div>
					<div style={{width:"100%"}}>
						<div style={{display:"inline-block", width: "32px", paddingLeft: "10px", position:"relative", left:"-15px", top:"10px"}}>
							<i className="material-icons" style={{color: "#5ae4c3"}}>email</i>
						</div>
						<TextField style={{position: "relative", width: "calc(100% - 30px)"}}
							hintText = "Email"
							hintStyle={{fontStyle: "italic", fontSize: "14px"}}
							multiLine = {true}
							fullWidth={false}
							style={{
								width: "calc(100% - 50px)"
							  , position: "relative"
							  , marginTop: "-10px"
							  , marginLeft: "6px"
							  , display:"inline-block"
							}}
							inputStyle={{
								fontSize: "16px"
							}}
							underlineStyle={{
								left: "1px"
							  , borderBottom: "0px solid #b0bec4"
							}}
							floatingLabelStyle={{
								fontWeight: "100",
								fontSize: "14px"
							}}
							defaultValue={vendor.email}
							key={vendor.email}
							onBlur={(evt)=>{
								this.props.STAGE({_id: vendor._id, email: evt.target.value})
							}}
						/>
					</div>
					<div style={{width:"100%"}}>
						<div style={{display:"inline-block", width: "32px", paddingLeft: "10px", position:"relative", left:"-15px", top:"10px"}}>
							<i className="material-icons" style={{color: "#5ae4c3"}}>web</i>
						</div>
						<TextField style={{position: "relative", width: "calc(100% - 30px)"}}
							hintText = "Web"
							hintStyle={{fontStyle: "italic", fontSize: "14px"}}
							multiLine = {true}
							fullWidth={false}
							style={{
								width: "calc(100% - 50px)"
							  , position: "relative"
							  , marginTop: "-10px"
							  , marginLeft: "6px"
							  , display:"inline-block"
							}}
							inputStyle={{
								fontSize: "16px"
							}}
							underlineStyle={{
								left: "1px"
							  , borderBottom: "0px solid #b0bec4"
							}}
							floatingLabelStyle={{
								fontWeight: "100",
								fontSize: "14px"
							}}
							defaultValue={vendor.web}
							key={vendor.web}
							onBlur={(evt)=>{
								this.props.STAGE({_id: vendor._id, web: evt.target.value})
							}}
						/>
					</div>
				</div>
				{/*<Phones objectID={vendor._id} />*/}
			</div>
		)
	}
}

export default connect(select, dataActions)(LeftSide)



// WEBPACK FOOTER //
// ./src/routes/manager/vendorForm/LeftSide.js